import { createEvent, restore, sample } from 'effector'

import { fx } from 'src/libs'
import {
  WebsiteBannerItem,
  WebsiteBannersRequest,
  WebsiteBannersResponse,
} from './types'

export const websiteBannersListMounted = createEvent<WebsiteBannersRequest>()

export const getWebsiteBanners = fx<
  WebsiteBannersRequest,
  WebsiteBannersResponse
>({
  method: 'GET',
  url: `/partner/material/website_banner`,
})

export const $websiteBannerItems = restore<WebsiteBannerItem[]>(
  getWebsiteBanners.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfWebsiteBannerItems = restore(
  getWebsiteBanners.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: websiteBannersListMounted,
  fn: ({ limit, page, filters }) => {
    let query = {
      limit,
      page,
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'lang'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query,
    }
  },
  target: getWebsiteBanners,
})
